import { Link } from "react-router-dom";
import { CLINIC } from "../../data/content";
import { MapPin, Phone, Mail, Star } from "lucide-react";
import LogoMark from "./LogoMark";

export default function Footer() {
  return (
    <footer className="bg-brand-blue-dark text-brand-cream mt-20">
      <div className="container-wide py-16 grid grid-cols-1 md:grid-cols-5 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <LogoMark size={56} className="shrink-0" />
            <span className="font-heading text-xl">Physio Hyve Clinic</span>
          </div>
          <p className="text-sm text-brand-cream/80 max-w-md">
            Personalised physiotherapy and rehabilitation for pain, injuries, neurological conditions and better movement — built around your condition and your goals.
          </p>
          <div className="flex items-center gap-2 mt-5">
            <Star className="fill-brand-amber text-brand-amber" size={16}/>
            <span className="text-sm">{CLINIC.rating} Google Rating · {CLINIC.reviewsCount} reviews</span>
          </div>
        </div>

        <div>
          <h4 className="font-heading text-sm uppercase tracking-widest mb-4 text-brand-cream/70">Care</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/services" className="hover:text-white">Services</Link></li>
            <li><Link to="/conditions" className="hover:text-white">Conditions</Link></li>
            <li><Link to="/services/acl-rehab" className="hover:text-white">ACL Rehabilitation</Link></li>
            <li><Link to="/services/neuro-rehab" className="hover:text-white">Neuro Rehabilitation</Link></li>
            <li><Link to="/maternal-care" className="hover:text-white">Maternal Care</Link></li>
            <li><Link to="/first-visit" className="hover:text-white">Your First Visit</Link></li>
            <li><Link to="/patient-stories" className="hover:text-white">Patient Stories</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-sm uppercase tracking-widest mb-4 text-brand-cream/70">Areas we serve</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/areas/najafgarh" className="hover:text-white" data-testid="footer-area-najafgarh">Physiotherapy in Najafgarh</Link></li>
            <li><Link to="/areas/uttam-nagar" className="hover:text-white" data-testid="footer-area-uttam-nagar">Physiotherapy in Uttam Nagar</Link></li>
            <li><Link to="/areas/rohini" className="hover:text-white" data-testid="footer-area-rohini">Physiotherapy in Rohini</Link></li>
            <li><Link to="/areas/peeragarhi" className="hover:text-white" data-testid="footer-area-peeragarhi">Physiotherapy in Peeragarhi</Link></li>
            <li><Link to="/areas/paschim-vihar" className="hover:text-white" data-testid="footer-area-paschim-vihar">Physiotherapy in Paschim Vihar</Link></li>
            <li><Link to="/areas/janakpuri" className="hover:text-white" data-testid="footer-area-janakpuri">Physiotherapy in Janakpuri</Link></li>
            <li><Link to="/team/amit-sharma" className="hover:text-white">Dr. Amit Sharma</Link></li>
            <li><Link to="/maternal-care" className="hover:text-white">Dr. Manishika Patait</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-sm uppercase tracking-widest mb-4 text-brand-cream/70">Visit us</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex gap-2"><MapPin size={16} className="mt-0.5 shrink-0"/> <span>{CLINIC.address}</span></li>
            <li className="flex gap-2"><Phone size={16} className="mt-0.5 shrink-0"/> <a href={`tel:${CLINIC.phoneRaw}`}>{CLINIC.phone}</a></li>
            <li className="flex gap-2"><Mail size={16} className="mt-0.5 shrink-0"/> <a href={`mailto:${CLINIC.email}`}>{CLINIC.email}</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-wide py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-brand-cream/60">
          <span>© {new Date().getFullYear()} Physio Hyve Clinic. All rights reserved.</span>
          <div className="flex gap-4">
            <Link to="/privacy" className="hover:text-white">Privacy</Link>
            <Link to="/terms" className="hover:text-white">Terms</Link>
            <Link to="/admin/login" className="hover:text-white" data-testid="footer-admin-login">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
